import React from 'react';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';
const UserInfoBlock = ({ user, publishedTime })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 32,
        user: user,
        className: s['author-avatar']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['author-username']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['author-userlink']
    }), publishedTime && /*#__PURE__*/ React.createElement(PublishedTime, {
        publishedTime: publishedTime,
        withoutText: true
    })));
UserInfoBlock.displayName = 'UserInfoBlock';
export default UserInfoBlock;

//# sourceMappingURL=UserInfoBlock.js.map